import { render, staticRenderFns } from "./StripeDemoForm.vue?vue&type=template&id=c6d2a9b0&scoped=true&"
import script from "./StripeDemoForm.vue?vue&type=script&lang=js&"
export * from "./StripeDemoForm.vue?vue&type=script&lang=js&"
import style0 from "./StripeDemoForm.vue?vue&type=style&index=0&id=c6d2a9b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d2a9b0",
  null
  
)

export default component.exports